import React from 'react';
import { MegaPackSalesLetter } from '../components/MegaPackSalesLetter';
export function LandingPage() {
  return <MegaPackSalesLetter data-id="element-496" data-mp="1nc19lm7tajof" />;
}